import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';

import TechnicalTypesManagerPage from 'src/pages/Dashboard/System/TechnicalTypes/TechnicalTypesManagerPage';
import systemOptionsStore from 'src/stores/systemOptionsStore';

const Distances = () => {
  const {
    distances: items,
    deleteDistance: deleteItem,
    deleteAllDistances: deleteAllItems,
    fetchDistances: fetchItems,
    isLoading,
    saveDistance: saveItem,
  } = systemOptionsStore(systemOptionsState => systemOptionsState);

  return (
    <TechnicalTypesManagerPage
      entityType="distances"
      storeSelectors={{ items, isLoading, fetchItems, saveItem, deleteItem, deleteAllItems }}
      i18nKeys={{
        prefix: 'system.distances',
        emptyPrefix: 'empty.distances',
        errorsPrefix: 'system.distances.errors',
      }}
      emptyIcon={<StraightenOutlinedIcon />}
      editorModalId="distance-editor"
      defaultIcon="location"
      showDescription={false}
    />
  );
};

export default Distances;
